/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useContext} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_FORGET_PASSWORD, API_UPLOADS } from '../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Route JSON]
-------------------------------------------------------------------*/
import { route, route_name } from "../@api.json";
/*------------------------------------------------------------------
[End Route JSON]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { Link, NavLink, useHistory } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
import sha1 from 'sha1';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Context]
-------------------------------------------------------------------*/
import { UserContext, LocationContext } from '../../../../context/container'
/*------------------------------------------------------------------
[End Context]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../../../style/general/node.entry.css';
import '../../../../style/admin/node.admin.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

import { countDown } from "../../../../functions";

const Screen = ({setting, loading, error}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    const [username, set_username] = useState('');

    const [email, set_email] = useState('');

    const [password, set_password] = useState('');

    const [password_look, set_password_look] = useState(false);

    const [handle_register, set_handle_register] = useState(false);

    const [refresh, set_refresh] = useState(false);

    const [wait, set_wait] = useState(0)

	//#region redux ------------------------------------------------

	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}

	//#endregion redux ---------------------------------------------

    /*--------------------------------------------------------------
    [Context]
    ----------------------------------------------------------------*/
    const { user, set_user } = useContext(UserContext);
    const { location, set_location } = useContext(LocationContext);
    /*--------------------------------------------------------------
    [End Context]
    ----------------------------------------------------------------*/

    if(STORAGE_USER){
        if(STORAGE_USER[0].level === 'guest'){
            history.push('/')
            set_location('public')
        }else if(STORAGE_USER[0].level === 'super'){
            history.push('/')
        }else if(STORAGE_USER[0].level === 'admin'){
            history.push('/')
        }else if(STORAGE_USER[0].level === 'user'){
            history.push('/')
        }
    }

    const _forget_password = () => {

        if(loading === true){
            return
        }

		loading(true);

		API_FORGET_PASSWORD(`${route}/forget_password__________`, {
            username: email,
			email: email,
            password: sha1(password),
            new_password: password
		})
        .then((response) => {
			if(response.data.result === 'success'){
                set_username('')
                set_email('')
                set_password('')
                error('Perubahan Password Telah terkirim. Harap verifikasi email untuk menyetujui')
                countDown(30, (e) => {
                    console.log(e)
                    set_wait(e)
                })
                console.log(response.data.data)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    useEffect(() => {

        set_location(history.location.pathname)

    }, [refresh])

    return (
        <>
            <Helmet>

                <meta name="description" content={'Forget Password'}/>
                <title>{'Forget Password'}</title>

            </Helmet>

            <div className="_bb-position-overlay-form">
                {
                    setting &&
                    <div className="_image">
                        <div className="_middle">
                            <img src={API_UPLOADS + setting.logo} style={{width: 150}} />
                            <br/>
                            <p style={{color: '#000', maxWidth: 400, margin: 'auto', textAlign: 'center', fontSize: 20}}>
                                {setting.description}
                            </p>
                        </div>
                    </div>
                }
                <div className="_form">
                    <div>
                        <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Forget</h1>
                        {/* <div className="_relative">
                            <p>Username</p>
                            <div className="_bb-input">
                                <input 
                                    placeholder="" 
                                    onChange={e => set_username(e.target.value)}
                                    value={username}
                                />
                            </div>
                        </div>
                        <br/> */}
                        <div className="_relative">
                            <p>Email</p>
                            <div className="_bb-input">
                                <input 
                                    placeholder="" 
                                    onChange={e => set_email(e.target.value)}
                                    value={email}
                                />
                            </div>
                        </div>
                        <br/>
                        <div className="_relative">
                            <p>New Password</p>
                            <div className="_row">
                                <div className="_bb-input">
                                    <input
                                        type={!password_look ? 'password' : 'text'} 
                                        placeholder="" 
                                        onChange={e => set_password(e.target.value)}
                                        value={password}
                                    />
                                </div>
                                <div onClick={() => {
                                    if(password_look){
                                        set_password_look(false)
                                    }else{
                                        set_password_look(true)
                                    }
                                }} style={{position: 'absolute', right: 15, top: 13, cursor: 'pointer'}}>
                                    <ion-icon name={password_look ? 'lock-open-outline' : 'lock-closed-outline'}></ion-icon>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className="_bb-btn" onClick={() => wait > 0 ? null : _forget_password()}>
                            {
                                wait > 0 ?
                                    wait
                                :
                                    'Reset'
                            }
                        </div> 
                        <div style={{height: 2, backgroundColor: '#eee', marginTop: 40, marginBottom: 40}}></div>
                        <p style={{marginTop: 16, textAlign: 'center'}}>Sudah ingat password? silahkan {` `} 
                            <NavLink 
                                to={{
                                    pathname: "/login",
                                }}
                                // activeClassName="__nav_active"
                                style={{color: '#118ab2'}}
                            >
                                Login
                            </NavLink>
                        </p>
                        <br/>
                        <br/> 
                    </div>
                </div>
            </div>
        </>
    );

}

export default Screen;